import Accordion from "@/components/base/Accordion";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/faq";
import { site } from "@/mocks/site";

export default function FaqSection() {
  return (
    <section id="sss" className="scroll-mt-24 bg-background-50 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Sıkça sorulan sorular"
            title="En çok merak edilenler"
            description="Aradığınız yanıtı bulamadıysanız WhatsApp'tan yazın; hızlıca yönlendirelim."
          />
        </Reveal>

        <Reveal>
          <div className="mx-auto mt-14 max-w-3xl">
            <Accordion items={faqs} />
          </div>
        </Reveal>

        <Reveal>
          <div className="mx-auto mt-10 flex max-w-3xl flex-col items-center justify-between gap-4 rounded-lg border border-background-300 bg-background-100 px-6 py-6 sm:flex-row">
            <p className="text-sm font-medium text-foreground-700">
              Sorunuz listede yok mu? WhatsApp'tan hemen yazabilirsiniz.
            </p>
            <a
              href={site.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-primary-500 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-whatsapp-line text-base" aria-hidden="true" />
              WhatsApp'tan Yaz
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}